import $ from 'jquery';
import * as config from '../../home24/core/config';

/**
 * adblocker detection mechanism
 */
export default class AdBlock {
  constructor() {
    this.$scope = $('body');

    this.delayedDetection();
  }

  /**
   * Method detects if in-browser DOM manipulation based advertisements blocking script is in use
   * @return {boolean}
   */
  isAdBlockerEnabled() {
    var x = document.getElementById('ad1');
    var xstyle = false;
    var attributesToCheck = [
      'MozBinding',
      'display',
      'position',
      'top',
      'left'
    ];
    var attributeCondition = ['none', 'inline', 'static', 'auto', 'auto'];
    var bRetVal = false;
    var i = 0;

    if (!x) {
      return true;
    }

    if (x.currentStyle) {
      // IE
      xstyle = x.currentStyle;
    } else if (document.defaultView && document.defaultView.getComputedStyle) {
      // Firefox & Chrome
      xstyle = document.defaultView.getComputedStyle(x, '');
    }

    while (i < attributesToCheck.length) {
      if (xstyle[attributesToCheck[i]] !== attributeCondition[i]) {
        if (undefined != xstyle[attributesToCheck[i]]) {
          bRetVal = true;
          break;
        }
      }
      i++;
    }

    return bRetVal;
  }

  /**
   * Method tries to determine if any iframe request blocking script was in use
   * @return {boolean}
   */
  requestBlockerEnabledByIframe() {
    /*
     * in case of Firefox browser we are unable to detect if iframe succeeded to load any content for different origin.
     * The same case is for mobile Safari browsers (iPad)
     * In this case, to avoid false positives, always assume that request were not blocked
     */
    if (
      $.browser.mozilla ||
      navigator.userAgent.match(/(iPad|iPhone|iPod touch)/i) ||
      ($.browser.webkit && !/chrome/.test(navigator.userAgent.toLowerCase()))
    ) {
      return false;
    }

    var iSuccess = 0;
    var iTotal = 0;

    this.$scope.find('[data-external-url] > iframe').each(function() {
      iTotal++;

      /*
       * In case of modern browsers accessing iframe content for different origin causes SecurityError.
       * SecurityError does not appear when iframe request was canceled by request blocking script
       */
      try {
        if (
          $(this)
            .contents()
            .find('body')
            .children().length > 0
        ) {
          iSuccess++;
        }
      } catch (exception) {
        iSuccess++;
      }
    });

    return iTotal > 0 && iSuccess === 0;
  }

  requestBlockerEnabledByScript() {
    var iSuccess = 0;
    var iTotal = 0;

    this.$scope.find('.dblclick-content').each(function() {
      var $this = $(this);
      var $firstChild = $this.children().eq(0);
      var $secondChild = $this.children().eq(1);

      iTotal++;

      if (!$firstChild.is('script')) {
        return;
      }

      if (!$secondChild.is('a,img')) {
        return;
      }

      iSuccess++;
    });

    return iTotal > 0 && iSuccess === 0;
  }

  /**
   * @return {Boolean}
   */
  check() {
    return (
      this.isAdBlockerEnabled() ||
      this.requestBlockerEnabledByIframe() ||
      this.requestBlockerEnabledByScript()
    );
  }

  /**
   * Method removes doubleclick content and replaces it with fallbacks
   */
  switchToFallbacks() {
    this.$scope.find('.fallback').each(function() {
      $(this)
        .removeClass('is-hidden')
        .parent()
        .find(
          '>[data-external-url], > script:first, > a:first, .dblclick-content'
        )
        .remove();
    });
  }

  /**
   * Method performs delayed check if any kind of adblocker is enabled on client side
   * If yes, removes doubleclick content and serves fallbacks
   * @trigger AdBlockDetected
   */
  delayedDetection() {
    window.setTimeout(() => {
      if (this.check()) {
        this.switchToFallbacks();
        $(window).trigger('AdBlockDetected');
      }
    }, config.getInt('marketing.delayedAdBlockDetectionTime'));
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/adblock.js
 **/